import { SharedSourcingStoreApi } from 'modules/sourcing-shared/types';
import { scrollToTop } from 'common/utils';

type HandleSourcingSharedChooseChannelBackControllerProps = {
  set: SharedSourcingStoreApi['setState'];
};

export const handleSourcingSharedChooseChannelBackController = ({
  set
}: HandleSourcingSharedChooseChannelBackControllerProps) => {
  scrollToTop();
  set({
    step: 'SELECTED_CANDIDATES'
  });
};
